const defaults = { size: 18, strokeWidth: 1.75 };

function svgProps({ size, strokeWidth, className }) {
  return {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    className,
    'aria-hidden': true,
    strokeWidth,
  };
}

export function IconAdd({ size = 18, className }) {
  return (
    <svg {...svgProps({ size, className })}>
      <path d="M12 5v14M5 12h14" stroke="currentColor" strokeLinecap="round" />
    </svg>
  );
}

export function IconSave({ size = 18, className }) {
  return (
    <svg {...svgProps({ size, className })}>
      <path
        d="M5 3h12l2 2v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
      <path d="M9 3v5h6V3M9 15h6" stroke="currentColor" strokeLinecap="round" />
    </svg>
  );
}

export function IconCancel({ size = 18, className }) {
  return (
    <svg {...svgProps({ size, className })}>
      <path d="M6 6l12 12M18 6 6 18" stroke="currentColor" strokeLinecap="round" />
    </svg>
  );
}

export function IconEdit({ size = 18, className }) {
  return (
    <svg {...svgProps({ size, className })}>
      <path
        d="M4 20h4l10-10-4-4L4 16v4Z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
      <path d="M13 7l4 4" stroke="currentColor" strokeLinecap="round" />
    </svg>
  );
}

export function IconDelete({ size = 18, className }) {
  return (
    <svg {...svgProps({ size, className })}>
      <path d="M4 7h16M9 7V5h6v2" stroke="currentColor" strokeLinecap="round" />
      <path
        d="M7 7l1 12h8l1-12"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconApprove({ size = 18, className }) {
  return (
    <svg {...svgProps({ size, className })}>
      <circle cx="12" cy="12" r="9" stroke="currentColor" />
      <path d="M8 12l2.5 2.5L16 9" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconReject({ size = 18, className }) {
  return (
    <svg {...svgProps({ size, className })}>
      <circle cx="12" cy="12" r="9" stroke="currentColor" />
      <path d="M9 9l6 6M15 9l-6 6" stroke="currentColor" strokeLinecap="round" />
    </svg>
  );
}

export function IconSend({ size = 18, className }) {
  return (
    <svg {...svgProps({ size, className })}>
      <path
        d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7Z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconSignIn({ size = 18, className }) {
  return (
    <svg {...svgProps({ size, className })}>
      <path
        d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M15 12H3"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconVote({ size = 18, className }) {
  return (
    <svg {...svgProps({ size, className })}>
      <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" />
      <path d="M8 12l3 3 5-6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconCopy({ size = 18, className }) {
  return (
    <svg {...svgProps({ size, className })}>
      <rect x="8" y="8" width="12" height="12" rx="2" stroke="currentColor" />
      <path
        d="M6 16H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconCheck({ size = 18, className }) {
  return (
    <svg {...svgProps({ size, className })}>
      <path d="M5 12l4 4L19 6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconSpinner({ size = 18, className }) {
  return (
    <svg {...svgProps({ size, className })} className={`icon-spinner ${className || ''}`.trim()}>
      <path
        d="M12 3a9 9 0 1 0 9 9"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function IconDownload({ size = 18, className }) {
  return (
    <svg {...svgProps({ size, className })}>
      <path d="M12 3v12M7 10l5 5 5-5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 20h16" stroke="currentColor" strokeLinecap="round" />
    </svg>
  );
}

export function IconPrint({ size = 18, className }) {
  return (
    <svg {...svgProps({ size, className })}>
      <path d="M6 9V4h12v5" stroke="currentColor" strokeLinejoin="round" />
      <rect x="6" y="14" width="12" height="7" rx="1" stroke="currentColor" />
      <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" stroke="currentColor" />
    </svg>
  );
}

export { defaults as iconDefaults };
